import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@bcc/lib/utils";
import { setSeparatorTestId } from "./separator.utils";

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  testId,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root> & {
  testId?: string;
}) {
  const finalTestId = testId ?? setSeparatorTestId(orientation);

  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      data-testid={finalTestId}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
